import type { HealthIndicatorViewId } from './peopleHealthNarrative';

export function healthChartToViewId(
  chart: 'health-insurance' | 'asthma' | 'cardiovascular' | 'lowBirthWeight'
): HealthIndicatorViewId {
  if (chart === 'health-insurance') return 'insurance';
  if (chart === 'asthma') return 'asthma';
  if (chart === 'cardiovascular') return 'cardiovascular';
  return 'low_birth_weight';
}

export function buildHealthIndicatorTokens(params: {
  viewId: HealthIndicatorViewId;
  locationName: string;
  latestYear: number | null;
  uninsuredPercent: string | null;
  trendSentence: string;
  comparisonSentence: string;
  cesLocationValue: number | null;
  cesCaliforniaValue: number | null;
  cesUnit: string;
  cesMetricLabel: string;
}): Record<string, string> {
  if (params.viewId === 'insurance') {
    return {
      locationName: params.locationName,
      latestYear: params.latestYear != null ? String(params.latestYear) : '—',
      healthMetricValue: params.uninsuredPercent ?? '—',
      healthInsuranceUniverse: 'residents',
      healthInsuranceMetricLabel: 'without health insurance',
      trendSentence: params.trendSentence,
      comparisonSentence: params.comparisonSentence,
    };
  }

  const value =
    params.cesLocationValue != null
      ? String(params.cesLocationValue)
      : '—';
  const comparison =
    params.cesCaliforniaValue != null
      ? ` California comparison: ${params.cesCaliforniaValue}${params.cesUnit}.`
      : '';

  return {
    locationName: params.locationName,
    latestYear: '—',
    healthMetricLabel: params.cesMetricLabel,
    healthMetricValue: value,
    healthMetricUnit: params.cesUnit,
    comparisonSentence: comparison,
    coverageSentence: '',
  };
}
